import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { dateRangeOptionsList } from '../../components/DateAndGranularityPicker/DateAndGranularityPicker';
import SCDashboardEnvironmentImpact from '../SiteCoordinatorDashboard/SCDashboardDesktop/SCDashboardEnvironmentImpact';

const ALL_FOOD_DONORS = 'all';

// the umbrella's impact: all its food donors, or the one picked
const UmbrellaFoodDonorEnvironmentImpact = ({ umbrellaFoodDonorId }) => {
  const [foodDonorId, setFoodDonorId] = useState(ALL_FOOD_DONORS);
  const foodDonors = useSelector(
    (state) => state.entities.foodDonors.byUmbrellaFoodDonorId[umbrellaFoodDonorId] || []
  );
  const sortedFoodDonors = [...foodDonors].sort((a, b) => (a.name || '').localeCompare(b.name || ''));

  return (
    <SCDashboardEnvironmentImpact
      filters={foodDonorId === ALL_FOOD_DONORS ? { donor_id: umbrellaFoodDonorId } : { food_donor_id: foodDonorId }}
      defaultDateRange={dateRangeOptionsList.thisYTD}
      showRescuerEffort={false}
      showTitle={false}
      filterControls={
        <FormControl variant="outlined" size="small" sx={{ minWidth: 220 }}>
          <InputLabel id="umbrella-impact-food-donor">Food Donor</InputLabel>
          <Select
            labelId="umbrella-impact-food-donor"
            label="Food Donor"
            value={foodDonorId}
            onChange={(event) => setFoodDonorId(event.target.value)}
          >
            <MenuItem value={ALL_FOOD_DONORS}>All food donors</MenuItem>
            {sortedFoodDonors.map((foodDonor) => (
              <MenuItem key={foodDonor.id} value={foodDonor.id}>
                {foodDonor.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      }
    />
  );
};

export default UmbrellaFoodDonorEnvironmentImpact;
